import React from 'react';
import { Col, Container, Row } from '@bootstrap-styled/v4';
import styled from 'styled-components';
import SectionTitle from './section-tag';
import IntroductionTitle from './introduction-title';
import IntroductionDesc from './introduction-desc';
import colors from 'shared-components/theme/colors';
import { baseURL } from 'shared-components/theme/helpers';
import AnimatedProgressBar from './progress';
import Media from 'shared-components/theme/medias';
import { gilroyBold, gilroySemibold } from 'shared-components/theme/fonts';
import ScrollAnimation from 'react-animate-on-scroll';

const Cost = () => {
    const costStructure = [
        {
            flag: `${baseURL}assets/images/geos/pakistan/flag_pk.svg`,
            label: 1.26,
            percentage: 40,
            color: '#3BF78A',
            textColor: '#04190D',
        },
        {
            flag: `${baseURL}assets/images/geos/pakistan/flag_ph.svg`,
            label: 2.07,
            percentage: 70,
            color: '#01411C',
            textColor: '#E8E7D8',
        },
        {
            flag: `${baseURL}assets/images/geos/pakistan/flag_ind.svg`,
            label: 2.52,
            percentage: 90,
            color: '#04190D',
            textColor: '#E8E7D8',
        },
    ];
    return (
        <Wrap id="cost">
            <ScrollAnimation animateIn="fadeInUp" animateOnce={true}>
                <SectionTitle tag={'THE COST'} />
            </ScrollAnimation>

            <ScrollAnimation
                animateIn="fadeInUp"
                animateOnce={true}
                delay={100}>
                <IntroductionTitle
                    title={'Save 90%. Scale 100%.'}
                    textColor={colors.geoGreen[100]}
                />
            </ScrollAnimation>
            <Row className="cost_row">
                <Col lg="9">
                    <ScrollAnimation
                        animateIn="fadeInUp"
                        animateOnce={true}
                        delay={150}>
                        <ProgresContainer>
                            {costStructure.map((progress, i) => (
                                <ProgressWrap key={i}>
                                    <img
                                        src={progress.flag}
                                        alt="ibex"
                                        width={69}
                                        height={46}
                                    />
                                    <AnimatedProgressBar
                                        label={progress.label}
                                        percentage={progress.percentage}
                                        height="45px"
                                        color={progress.color}
                                        textColor={progress.textColor}
                                    />
                                </ProgressWrap>
                            ))}
                            <Comparison>
                                <li>
                                    <img
                                        src={`${baseURL}assets/images/geos/pakistan/flag_uk.svg`}
                                    />
                                    <span>$16.86</span>
                                </li>
                                <li>
                                    <img
                                        src={`${baseURL}assets/images/geos/pakistan/flag_usa.svg`}
                                    />
                                    <span>$21</span>
                                </li>
                                <li>
                                    <span>Up to 90% in savings</span>
                                </li>
                            </Comparison>
                            <p className="cost_txt">• Cost per hour</p>
                        </ProgresContainer>
                    </ScrollAnimation>
                </Col>
                <Col lg="3">
                    <ScrollAnimation
                        animateIn="fadeInUp"
                        animateOnce={true}
                        delay={200}>
                        <IntroductionDesc
                            desc={
                                '<b>Save 60% vs. Leading Offshore Options </b>'
                            }
                            textColor={colors.geoGreen[100]}
                        />
                        <IntroductionDesc
                            desc={
                                'Pakistan offers 40-60% savings compared to traditional offshoring hubs — with no sacrifice in quality.'
                            }
                            textColor={colors.geoGreen[100]}
                        />
                    </ScrollAnimation>
                </Col>
            </Row>
        </Wrap>
    );
};

export default Cost;

const Wrap = styled.div`
    margin-top: 80px;
    scroll-margin-top: 80px;
    .cost_txt {
        font-size: 17px;
        font-faily: ${gilroySemibold};
        font-weight: 600;
        color: ${colors.geoGreen[100]};
        opacity: 0.5;
        margin: 0;
        ${Media('large')} {
            gap: 1.785vw;
        }
        ${Media('laptops')} {
            font-size: 14px;
        }
        ${Media('mobile')} {
            font-size: 12px;
            gap: 15px;
        }
    }
`;
const ProgresContainer = styled.div`
    margin-top: 40px;
    display: flex;
    flex-direction: column;
    gap: 30px;

    ${Media('large')} {
        margin-top: 2.38vw;
        gap: 1.785vw;
    }
    ${Media('mobile')} {
        margin-top: 20px;
        gap: 15px;
    }
`;

const ProgressWrap = styled.div`
    display: flex;
    align-items: center;
    gap: 60px;

    ${Media('large')} {
        gap: 3.569vw;
    }
    ${Media('laptops')} {
        gap: 20px;
    }
    ${Media('mobile')} {
        gap: 15px;
    }
`;

const Comparison = styled.ul`
    border: 1px solid ${colors.geoGreen[100]};
    border-radius: 10px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    max-width: max-content;
    padding: 0;
    margin: 0;
    li {
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 10px;
        border-right: 1px solid ${colors.geoGreen[100]};

        &:last-child {
            border-right: 0;
        }
        ${Media('mobile')} {
            border-right: 0;
        }
        span {
            font-size: 24px;
            font-family: ${gilroyBold};
            font-weight: 700;

            ${Media('laptops')} {
                font-size: 22px;
            }
            ${Media('mobile')} {
                font-size: 16px;
            }
        }

        &:last-child {
            span {
                font-size: 20px;
                color: ${colors.geoGreen[90]};
                font-weight: 600;
                font-family: ${gilroySemibold};
                ${Media('mobile')} {
                    font-size: 14px;
                }
            }
        }
    }
`;
